import React from 'react';
import ObjectChangeSetsListWithSnapshots from './ObjectChangeSetsListWithSnapshots';
import ButtonControls from './ButtonControls';
import { useTranslation } from 'react-i18next';
export default function ChangeSetListWithReviewButtonControls(_ref) {
  let {
    canShowStartTrackingChangesButton = true,
    reviewedObject,
    reviewedObjectClass,
    snapshotsContainingObject,
    reviewType,
    snapshotsResetDataFn,
    showSnapshotsForAllReviewTypes,
    isLoading,
    claimGroup,
    createChangeSet,
    finalizeChangeSet,
    approveChangeSet,
    rejectChangeSet
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ButtonControls, {
    canShowStartTrackingChangesButton: canShowStartTrackingChangesButton,
    reviewedObject: reviewedObject,
    reviewedObjectClass: reviewedObjectClass,
    loading: isLoading,
    claimGroup: claimGroup,
    createChangeSet: createChangeSet,
    finalizeChangeSet: finalizeChangeSet,
    approveChangeSet: approveChangeSet,
    rejectChangeSet: rejectChangeSet,
    buttonName: t('start_tracking_changes'),
    underManagerReviewButtonName: t('complete_review'),
    managerQAReviewButtonName: 'Tracking Changes is completed',
    acceptChangesButtonText: 'Accept QA Tracking Changes',
    rejectChangesButtonText: 'Reject QA Tracking Changes',
    reviewType: reviewType
  }), /*#__PURE__*/React.createElement(ObjectChangeSetsListWithSnapshots, {
    object: snapshotsContainingObject // row.data.project
    ,
    reviewType: reviewType,
    resetData: snapshotsResetDataFn,
    showAllReviewTypes: showSnapshotsForAllReviewTypes
  }));
}